document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(
    ".mega-menu-mobile__menu-wrapper"
  );
  const detailsWrapper = document.querySelector(
    ".mega-menu-mobile__details-wrapper"
  );
  const backButton = document.getElementById("mega-menu-mobile-back-btn");
  const menusWrapper = document.querySelector(
    ".mega-menu-mobile__menus-wrapper"
  );

  // Handle menu click to show details
  menuItems.forEach((item) => {
    item.addEventListener("click", function () {
      const menuId = this.id;
      const detailSection = document.getElementById(`${menuId}-detail`);

      if (detailSection) {
        detailsWrapper.classList.remove("hidden");
        menusWrapper.classList.add("hidden");

        document
          .querySelectorAll(".mega-menu-mobile__detail-items-wrapper")
          .forEach((section) => {
            section.classList.add("hidden");
          });

        detailSection.classList.remove("hidden");
      }
    });
  });

  // Handle back button click to return to main menu
  backButton.addEventListener("click", function () {
    detailsWrapper.classList.add("hidden");
    menusWrapper.classList.remove("hidden");
  });

  // Handle scroll padding-top adjustment
  const menuWrapper = document.querySelector(".mega-menu-mobile__wrapper");

  if (!menuWrapper) return;

  window.addEventListener("scroll", function () {
    const scrollPosition = window.scrollY;
    let newPadding = Math.max(41 - scrollPosition, 0);
    menuWrapper.style.paddingTop = `${newPadding}px`;
  });
});
